import React, { useState } from 'react';
import styled from 'styled-components';
import { useMutation } from '@apollo/react-hooks';
import { withRouter } from 'react-router-dom';
import Button from './Button';
import colors from '../styles/colors';
import { PASSWORD_FORGOT } from '../graphql/queries';
import { getErrorMessage } from '../util/ErrorUtil';
import Input from './Input';
import Icon from './Icon';
import Error from './Error';
import Success from './Success';
import { IconEnum as Icons } from './Icons';
import { FadeIn } from './Animation';
import { media } from '../util/MediaQuery';

const Content = styled.div`
  align-items: center;
  justify-content: center;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: ${colors.white};
  position: relative;
  border-radius: 5px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  margin: auto;
  overflow-y: auto;
  ${media.desktop`
    &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
    padding: 30px;
    width: 400px;
  `};

  ${media.mobile`
    height: 100vh;
    width: 100vw;
    padding: 10px;
  `};
  ${media.desktop`
    min-height: 85vh !important;
    max-height: 85vh !important; 
  `};
  ${media.tablet`
    min-height: 100vh;
    max-height: 100vh; 
  `};
`;

const TopText = styled.div`
  font-size: 2rem;
  text-align: center;
`;

const BackContainer = styled.div`
  display: flex;
  cursor: pointer;
  position: absolute;
  align-items: center;
  top: 25px;
  left: 25px;
`;

const BackText = styled.div`
  margin-left: 5px;
  color: ${colors.grey3};
  font-size: 1.4rem;
`;
const ButtonContainer = styled.div`
  padding-top: 20px;
`;

function ForgotPassword({ history }) {
  const [email, setEmail] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [passwordForgot] = useMutation(PASSWORD_FORGOT, {
    variables: {
      email,
    },
    onError(error) {
      setErrorMsg(getErrorMessage(error));
    },
    onCompleted(data) {
      if (data?.passwordForgot?.message) {
        setSuccessMsg(data.passwordForgot.message);
        setEmail('');
      } else {
        setErrorMsg('Something went wrong, please contact support');
      }
    },
  });
  return (
    <>
      <Content>
        <FadeIn duration={0.5}>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              passwordForgot();
            }}
          >
            <TopText>Don't worry, we'll help you out.</TopText>
            <Input
              header="EMAIL"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              width="100%"
            />
            <ButtonContainer>
              <Button
                text="SEND RESET INSTRUCTIONS"
                type="submit"
                width="fit-content"
              />
            </ButtonContainer>
            <BackContainer onClick={() => history.push('/Login')}>
              <Icon icon={Icons.LeftArrow} size={14} active />
              <BackText>Back</BackText>
            </BackContainer>
            {errorMsg && <Error error={errorMsg} margin="20px 0px 0px 0px" position="relative" />}
            {successMsg && (
              <Success message={successMsg} margin="20px 0px 0px 0px" position="relative" />
            )}
          </Form>
        </FadeIn>
      </Content>
    </>
  );
}

export default withRouter(ForgotPassword);
